module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"blocks":{"fetchError":"For some reason your blocks didn’t load. Try again after refreshing the page.","saveError":"For some reason your block didn’t save. Try saving again.","deleteError":"For some reason your block didn’t get deleted. Try deleting it again.","updateError":"For some reason the changes to your block didn’t update. Try making them again."}}}')
  delete Component.options._Ctor
}
